// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ClaimPipProgram = t.struct({
    description: t.String,
    internalRecall: t.String,
    pipNumber: t.String
}, {
    name: 'ClaimPipProgram',
    strict: true
});

export const getDefaultState = () => new ClaimPipProgram({
    description: '',
    internalRecall: '',
    pipNumber: ''
});

export default ClaimPipProgram;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-pip-program.js